<template>
  <div :class="$style.root">
    <a
      v-if="url"
      :href="url"
      target="_blank"
      :class="$style.link"
    >
      <LayoutImageWithCaptionComponent>
        <template #image>
          <CoreImageComponent
            v-if="image"
            :image="image"
            :class="$style.coverImage"
            :showCaption="false"
            :data-orientation="getOrientation(image)"
          />
        </template>

        <template
          #caption
          v-if="label"
        >
          <span :class="$style.title">{{ label }}</span>
        </template>
      </LayoutImageWithCaptionComponent>
    </a>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    url: String,
    image: Object,
    label: {
      type: String,
      required: false
    }
  })

  const getOrientation = (image) => {
    if (image?.width && image?.height) {
      return image.width > image.height ? 'landscape' : 'portrait'
    }
  }
</script>

<style module>
  .root {
  }

  .link {
    composes: reset-link from global;
  }

  .title {
    composes: font-helvetica font-size-small from global;
    text-decoration-line: underline;
  }


  .link:hover .title {
    text-decoration-line: none;
  }

  .coverImage {
    --base--image--object-fit: contain;
    --base--image--object-position: center;

    display: flex;
    justify-content: center;
  }

  .coverImage img {
  }

  .coverImage[data-orientation='portrait'] {
    --base--image--object-fit: cover;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
</style>
